import l10n from '../../../shared/strings';

export const resolveChannelLabel = (channelId, salesChannels = []) => {
  const normalizedChannelId = String(channelId);

  const match = salesChannels.find(
    (salesChannel) => String(salesChannel._id) === normalizedChannelId
      || salesChannel.name === normalizedChannelId
      || salesChannel.type === normalizedChannelId,
  );

  return match?.name || `${normalizedChannelId.charAt(0).toUpperCase()}${normalizedChannelId.slice(1)}`;
};

export const resolveChannelLabels = (channelIds = [], salesChannels = []) => (
  channelIds.map((channelId) => resolveChannelLabel(channelId, salesChannels))
);

export const showPublishedToChannelToast = ({
  Toast,
  channelId,
  channelIds,
  salesChannels = [],
}) => {
  const resolvedChannelIds = channelIds?.length
    ? channelIds
    : (channelId ? [channelId] : []);

  if (!resolvedChannelIds.length) {
    return;
  }

  if (resolvedChannelIds.length === 1) {
    const channelLabel = resolveChannelLabel(resolvedChannelIds[0], salesChannels);
    Toast(l10n.TOAST.PUBLISHED_TO_CHANNEL(channelLabel), { type: 'success' });
    return;
  }

  const channelLabels = resolveChannelLabels(resolvedChannelIds, salesChannels);
  Toast(l10n.TOAST.PUBLISHED_TO_CHANNELS(channelLabels), { type: 'success' });
};
